import React from 'react'
import { Typography } from '@material-ui/core'
import { parse } from 'node-html-parser'
import { makeStyles } from '@material-ui/core/styles'
import cx from 'classnames'
import colors from '../../theme/variables/colors'

// Function to add ids to all h2s based on their title, to support marketing directly linking to section
function parsedHtml(content) {
  try {
    const parsedContent = parse(content)
    const allh2s = parsedContent?.querySelectorAll('h2')
    if (allh2s && allh2s.length > 0) {
      allh2s.forEach((h2) => {
        const node_title = h2.innerHTML
          ?.replace(/<[^>]+>/g, '')
          .replace(/\s/g, '_')
          .toLowerCase()
        if (!h2.id) {
          h2.id = node_title
          const starter = 'id="'
          h2.rawAttrs = starter.concat(node_title, '"')
        }
      })
    }
    return parsedContent.toString()
  } catch {
    return content
  }
}
const useStyles = makeStyles((theme) => ({
  default: {
    '& a': {
      color: colors.GOLDEN_BASE,
    },
  },
}))

const Html = ({ className, title, content }) => {
  const classes = useStyles()

  return (
    <>
      {title && (
        <Typography variant="h2" style={{ textAlign: 'center' }}>
          {title}
        </Typography>
      )}
      {content && (
        <div
          key={new Date().getTime()}
          className={cx(classes.default, className)}
          dangerouslySetInnerHTML={{ __html: parsedHtml(content) }}
        />
      )}
    </>
  )
}

export default Html
